<template>
  <div>
    <div class="card mb-3">
      <div class="p-3">
        <h5 class="mb-0">
          {{ research.title }}
        </h5>
        <div class="text-muted" v-if="research.description">
          {{ research.description }}
        </div>
      </div>

      <table class="table m-0">
        <tr v-if="research.start_date">
          <td>
            <strong>{{ $t('word.start_date') }}</strong>
          </td>
          <td>
            {{ research.start_date }}
          </td>
        </tr>
        <tr v-if="research.end_date">
          <td>
            <strong>{{ $t('word.end_date') }}</strong>
          </td>
          <td>
            {{ research.end_date }}
          </td>
        </tr>
        <tr>
          <td>
            <strong>{{ $t('word.status') }}</strong>
          </td>
          <td>
            <v-research-status-badge
              :status="research.status"
            />
          </td>
        </tr>
        <tr>
          <td>
            <strong>{{ $t('word.group_size') }}</strong>
          </td>
          <td>
            {{ research.group_size }}
            {{ $tc('word.participant', 2).toLowerCase() }}
          </td>
        </tr>
        <tr>
          <td>
            <strong>{{ $t('word.research_type') }}</strong>
          </td>
          <td>
            {{ research.research_type.name }}
          </td>
        </tr>
        <tr v-if="research.commercial && research.commercial.published_at">
          <td>
            <strong>{{ $t('phrase.published_at') }}</strong>
          </td>
          <td>
            {{ research.commercial.published_at }}
          </td>
        </tr>
        <tr v-if="research.commercial && research.commercial.categories">
          <td>
            <strong>{{ $t('word.categories') }}</strong>
          </td>
          <td>
            <div
              v-for="category in research.commercial.categories"
              :key="category.id"
              class="badge badge-success mr-1 mb-1"
            >
              {{ category.name }}
            </div>
            <div
              v-if="research.commercial.categories.length === 0"
            >
              -
            </div>
          </td>
        </tr>
      </table>
    </div>

    <div class="card" v-if="research.proposal">
      <div class="card-header p-3">
        <h5 class="m-0">
          <span class="mr-2">{{ research.proposal.title }}</span>
          <span class="badge text-white bg-cr-red-black badge-pill">
            <i class="fa fa-file-text"></i>  {{ $t('word.research_proposal') }}
          </span>
        </h5>
      </div>
      <div class="p-3">
        <div class="mb-2" v-if="research.proposal.introduction">
          <strong>{{ $t('word.introduction') }}</strong>
          <p class="m-0" v-html="research.proposal.introduction"></p>
        </div>
        <div class="mb-2" v-if="research.proposal.research_questions">
          <strong>{{ $tc('word.research_question', 2) }}</strong>
          <p class="m-0" v-html="research.proposal.research_questions"></p>
        </div>
        <div class="mb-2" v-if="research.proposal.research_setup">
          <strong>{{ $t('word.research_setup') }}</strong>
          <p class="m-0" v-html="research.proposal.research_setup"></p>
        </div>
        <div class="mb-2" v-if="research.proposal.target_group_information">
          <strong>{{ $t('word.target_group_information') }}</strong>
          <p class="m-0" v-html="research.proposal.target_group_information"></p>
        </div>
        <div class="mb-2" v-if="research.proposal.deliverables">
          <strong>{{ $t('word.deliverables') }}</strong>
          <p class="m-0" v-html="research.proposal.deliverables"></p>
        </div>
        <div v-if="research.proposal.price_description">
          <strong>{{ $t('phrase.price_description') }}</strong>
          <p class="m-0" v-html="research.proposal.price_description"></p>
        </div>
      </div>
      <div
        v-if="research.proposal.price"
        class="card-footer text-right"
      >
        <div class="d-flex justify-content-between text-bold">
          <div>
            {{ $t('word.total_price') }}
          </div>
          {{ toPrettyPrice(research.proposal.price) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResearchStatusBadge from '@/common/components/research/ResearchStatusBadge.vue';
import {
  stringToPrettyDate,
  toFormattedDate,
  toPrettyPrice,
} from '@/common/utils/formatting';
import {
  fetchCommercialCategories,
} from '@/organisation/api';

export default {
  name: 'ResearchGeneralInfo',
  components: {
    'v-research-status-badge': ResearchStatusBadge,
  },
  props: {
    research: {
      type: Object,
      required: true,
    },
  },
  methods: {
    toPrettyPrice,
    toFormattedDate,
    stringToPrettyDate,
    async fetchCommercialCategories() {
      const response = await fetchCommercialCategories();
      this.categories = response.data.map((el) => ({
        id: el.id,
        name: el.name,
      }));
    },
  },
  data() {
    return {
      categories: null,
    };
  },
  created() {
    this.fetchCommercialCategories();
  },
};
</script>
